module.exports = __webpack_public_path__ + "static/media/scrubblitz-2.14fdcb5a.jpg";